export let labOrderSaleFrom = [
  { value: 'MALL', label: '线上订单' },
  { value: 'CHANNEL', label: '渠道订单' }
]
export let companyLable = [
  { value: 'BRANCH', label: '分/子公司' },
  { value: 'AGENT', label: '外部代理商' }
]
